import { gql } from '@apollo/client'

export default gql(`
    mutation forceLogout($user: String! $project: String) {
        forceLogout(
            user: $user
            project: $project
        ) {
            status
            error 
            message 
        }
    }
`)
